import React, { useState, useEffect } from "react";
import api from "../../services/axiosInstance";
import {
  FaSearch,
  FaCube,
  FaDraftingCompass,
  FaSun, 
  FaChevronLeft,
  FaChevronRight,
  FaChalkboardTeacher,
} from "react-icons/fa";
import CourseDetailsCard from "../Prof/CourseDetailsCard";
import CourseCard from "../../components/course/CourseCard";
import { FaBuilding, FaEye, FaPalette, FaGraduationCap } from "react-icons/fa";
import UpcomingCourses from "../../components/course/UpcomingCourses";
import RateProfessorModal from "../../components/modals/RateProfessorModal";

const categories = {
  Tous: {
    description: "Toutes les formations disponibles",
    icon: <FaSearch className="text-2xl" />,
  },
  Avenir: {
    description: "Prochaines sessions de formation",
    icon: <FaChalkboardTeacher className="text-2xl " />,
  },
  Architecture: { 
    description: "Formations BIM et dessin technique",
    icon: <FaBuilding className="text-2xl" />,
  },
  Rendering: { 
    description: "Rendu photoréaliste et visualisation 3D",
    icon: <FaEye className="text-2xl" />,
  },
  Design: {
    description: "Design graphique et retouche photo",
    icon: <FaPalette className="text-2xl" />,
  },
  Académique: {
    description: "Ressources théoriques et académiques",
    color: "from-amber-500 to-amber-700",
    icon: <FaGraduationCap className="text-2xl" />,
  },
};

const levelData = {
  Débutant: {
    bg: "bg-emerald-100",
    badge: "bg-emerald-600 text-white",
    color: "from-emerald-500 to-emerald-700",
  },
  Intermédiaire: {
    bg: "bg-teal-100",
    badge: "bg-teal-600 text-white",
    color: "from-teal-500 to-teal-700",
  },
  Avancé: {
    bg: "bg-green-100",
    badge: "bg-green-700 text-white",
    color: "from-green-600 to-green-800",
  },
};


const AllCoursesPublic = () => {
  const [profRatingModal, setProfRatingModal] = useState({
  isOpen: false,
  profId: null,
  onSubmitted: null,
});
  const [selectedCategory, setSelectedCategory] = useState("Tous");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [likedCourses, setLikedCourses] = useState({});
  const [savedCourses, setSavedCourses] = useState({});
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [coursesPerPage] = useState(6);

const isAcademique = selectedCategory === "Académique";
const fetchUpcomingCourses = async () => {
  try {
    setLoading(true);
    const { data } = await api.get("/timeline/upcoming-from-today");
    console.log("Raw upcoming courses data:", data);
    const transformed = data.map(course => ({
      // ✅ FIX ID
      id: course.course_id,

      name: course.name,
      title: course.name,
      category: course.category,
      niveau: course.niveau,
      icon: course.icon,

      start_date: course.start_date,
      duration: course.duration,

      // ✅ OPTIONAL (backend doesn’t send price yet)
      price: course.price,

      gradient: getRandomGradient(),

      // ✅ REAL instructor data
      instructor: {
        id: course.instructor_id,
        name: course.instructor_name,
        email: course.instructor_email,
        wilaya: course.instructor_wilaya,
        bio: course.instructor_bio,
        achievements: Array.isArray(course.instructor_achievements)
          ? course.instructor_achievements
          : [course.instructor_achievements],
        gradient: getInstructorGradient(),
      },
    }));

    setCourses(transformed);
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};


useEffect(() => {
  if (selectedCategory === "Avenir") {
    fetchUpcomingCourses();
  } else {
    const fetchData = async () => {
      try {
        const { data } = await api.get("/courses/");
        const transformedCourses = data.map((course) => ({
          duree: course.duree,
          prerequis: course.prerequis,
          id: course.id,
          name: course.name,
          niveau: course.niveau,
          title: course.title,
          description: course.description,
          certificat: course.certificat,
          programme: course.programme,
          learn: course.learn,
          price: course.price
            ? `${course.price.toLocaleString()} DA`
            : "Prix non disponible",
          gradient: getRandomGradient(),
          icon: course.icon,
          category: course.category,
          instructor: {
            id:course.prof_id,
            name: course.instructor_name,
            role: course.instructor_role,
            email: course.instructor_email,
            phone: course.instructor_phone,
            wilaya: course.instructor_wilaya,
            bio: course.instructor_bio,
            achievements: course.instructor_achievements,
            gradient: getInstructorGradient(),
          },
        }));

        setCourses(transformedCourses);
        await fetchUserPreferences();
      } catch (error) {
        console.error("Error fetching courses:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData(); // fetch all courses
  }
}, [selectedCategory]);

  // Fetch latest courses + user preferences
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await api.get("/courses/");
        const transformedCourses = data.map((course) => ({
          duree: course.duree,
          prerequis: course.prerequis,
          id: course.id,
          name: course.name,
          niveau: course.niveau,
          title: course.title,
          description: course.description,
          certificat: course.certificat,
          programme: course.programme,
          learn: course.learn,
          price: course.price
            ? `${course.price.toLocaleString()} DA`
            : "Prix non disponible",
          gradient: getRandomGradient(),
          icon: course.icon,
          category: course.category,
          instructor: {
            id:course.prof_id,
            name: course.instructor_name,
            role: course.instructor_role,
            email: course.instructor_email,
            phone: course.instructor_phone,
            wilaya: course.instructor_wilaya,
            bio: course.instructor_bio,
            achievements: course.instructor_achievements,
            gradient: getInstructorGradient(),
          },
        }));

        setCourses(transformedCourses);
        await fetchUserPreferences();
      } catch (error) {
        console.error("Error fetching courses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

useEffect(() => {
  setCurrentPage(1);
}, [searchTerm]);

useEffect(() => {
  setCurrentPage(1);
}, [selectedCategory]);

  const getCourseBenefits = (courseId) => {
    const course = courses.find((c) => c.id === courseId);
    return course?.learn ? [course.learn] : ["Compétences pratiques avancées"];
  };

  
const filteredCourses = courses.filter((course) => {
  const searchLower = searchTerm.toLowerCase();

  const matchesSearch =
    (course.title && course.title.toLowerCase().includes(searchLower)) ||
    (course.description && course.description.toLowerCase().includes(searchLower)) ||
    (course.instructor?.name &&
      course.instructor.name.toLowerCase().includes(searchLower)) ||
    (course.name && course.name.toLowerCase().includes(searchLower));

  const matchesCategory =
    selectedCategory === "Tous" ||
    selectedCategory === "Avenir" ||
    course.category?.toLowerCase() === selectedCategory.toLowerCase();
 return matchesSearch && matchesCategory;
});

  const getCoursePrerequisites = (courseId) => {
    const course = courses.find((c) => c.id === courseId);
    return course?.prerequis
      ? [course.prerequis]
      : ["Aucun prérequis nécessaire"];
  };

  const getInstructorInfo = (courseId) => {
    const course = courses.find((c) => c.id === courseId);
    if (!course) return {};
    return {
      name: course.instructor.name,
      email: course.instructor.email,
      phone: course.instructor.phone,
      wilaya: course.instructor.wilaya,
      bio: course.instructor.bio,
      achievements: Array.isArray(course.instructor.achievements)
        ? course.instructor.achievements
        : [course.instructor.achievements],
    };
  };

  const registerCourseNoSubscripption = async (courseName, courseId) => {
    const phoneNumber = "213549075577";
    const message = `Bonjour ! Je suis intéressé(e) par la formation "${courseName}". Pouvez-vous me donner plus d'informations ?`;

    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappURL, "_blank");
  };
  // Fetch liked and saved courses
  const fetchUserPreferences = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) return;

      const { data } = await api.get("/users/preferences", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const likedMap = data.likedCourses || {};
      const savedMap = data.savedCourses || {};

      setLikedCourses(likedMap);
      setSavedCourses(savedMap);
    } catch (error) {
      console.error("Error fetching preferences:", error);
    }
  };

  // Helper functions
  const getRandomGradient = () => {
    const gradients = [
      "from-blue-600 to-blue-800",
      "from-red-600 to-red-800",
      "from-green-600 to-teal-600",
      "from-purple-600 to-purple-800",
      "from-orange-600 to-orange-800",
      "from-indigo-600 to-indigo-800",
    ];
    return gradients[Math.floor(Math.random() * gradients.length)];
  };

  const getInstructorGradient = () => {
    const gradients = [
      "from-blue-500 to-purple-600",
      "from-red-500 to-pink-600",
      "from-green-500 to-teal-600",
      "from-purple-500 to-pink-600",
      "from-orange-500 to-red-600",
      "from-indigo-500 to-purple-600",
    ];
    return gradients[Math.floor(Math.random() * gradients.length)];
  };

  const getCourseIcon = (category) => {
    const iconMap = {
      architecture: <FaCube className="text-white text-3xl" />,
      design: <FaDraftingCompass className="text-white text-3xl" />,
      rendering: <FaSun className="text-white text-3xl" />,
      bim: <FaCube className="text-white text-3xl" />,
      cad: <FaDraftingCompass className="text-white text-3xl" />,
      default: <FaCube className="text-white text-3xl" />,
    };
    return iconMap[category?.toLowerCase()] || iconMap.default;
  };

  // Toggle like
  const toggleLike = async (courseId) => {
    const newLikedState = !likedCourses[courseId];
    const token = localStorage.getItem("accessToken");

    if (!token) {
      alert("Veuillez vous connecter pour aimer ce cours");
      return;
    }

    try {
      await api.post(
        "/courses/like",
        { courseId, liked: newLikedState },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      );

      setLikedCourses((prev) => ({ ...prev, [courseId]: newLikedState }));
    } catch (error) {
      console.error("Error liking course:", error);
      alert("Erreur lors de la mise à jour du like");
    }
  };

  // Toggle save
  const toggleSave = async (courseId) => {
    const newSavedState = !savedCourses[courseId];
    const token = localStorage.getItem("accessToken");

    if (!token) {
      alert("Veuillez vous connecter pour sauvegarder ce cours");
      return;
    }

    try {
      await api.post(
        "/courses/save",
        { courseId, saved: newSavedState },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      );
 
      setSavedCourses((prev) => ({ ...prev, [courseId]: newSavedState }));
    } catch (error) {
      console.error("Error saving course:", error);
      alert("Erreur lors de la mise à jour de la sauvegarde");
    }
  };

  const registerCourse = async (courseId) => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      alert("Connectez-vous d'abord !");
      return;
    }

  };

  const showCourseDetails = (courseId) =>
    (window.location.href = `/courses/${courseId}`);
  const showCategoryBrowser = () => (window.location.href = "/all-courses");

  // Pagination logic
  const indexOfLastCourse = currentPage * coursesPerPage;
  const indexOfFirstCourse = indexOfLastCourse - coursesPerPage;
  const currentCourses = filteredCourses.slice(indexOfFirstCourse, indexOfLastCourse);
const totalPages = Math.ceil(filteredCourses.length / coursesPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  if (loading)
    return (
      <section className="py-20 bg-gray-50 text-center">
        <div className="animate-pulse text-gray-500">
          Chargement des formations...
        </div>
      </section>
    );

  return (
    <section id="formations" className="py-20 bg-gray-50">
      
<div className="w-full px-14 mb-4">
  <div className="relative">
    <FaSearch className="absolute z-50 left-4 top-1/2 -translate-y-1/2 text-gray-400" />
    <input
      type="text"
      placeholder="Rechercher une formation..."
      className="
        w-full pl-12 pr-4 py-3 
        border border-gray-300 rounded-xl 
        bg-white/70 backdrop-blur-sm
        shadow-sm
        focus:outline-none 
        focus:ring-2 focus:ring-gray-700 
        focus:border-transparent
        transition-all duration-200
      "
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
  </div>
</div>

      <div className="max-w-7xl mx-auto px-4">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-12">
  {Object.entries(categories).map(([key, cat]) => (
    <button
      key={key}
      onClick={() => setSelectedCategory(key)}
      className={`
  p-4 rounded-2xl text-left transition-all duration-300
  text-emerald-900 shadow-md hover:shadow-xl
  border border-black/5
  hover:scale-[1.02] active:scale-[0.98]
  ${selectedCategory === key
    ? "ring-1 ring-offset-0 ring-emerald-200 ring-offset-[#F7F8F5] shadow-2xl"
    : "hover:bg-[#F2F3EF]"
  }
  backdrop-blur-sm bg-[#F7F8F5]
`}

    >
      <div className="flex items-center gap-3 mb-2">
        <div className="p-2 bg-white/20 rounded-lg backdrop-blur-sm">
          {cat.icon}
        </div>
        <span className="font-bold text-lg">{key}</span>
      </div>
      <p className="text-sm opacity-90 font-medium">{cat.description}</p>
    </button>
  ))}
</div>



       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {isAcademique && (
    <div
      onClick={() => (window.location.href = "/academic")}
      className="cursor-pointer rounded-2xl p-6 
bg-gradient-to-br from-green-500 to-emerald-700 
text-white shadow-lg hover:shadow-2xl 
hover:scale-[1.03] transition-all duration-300">
      <h3 className="text-xl font-bold mb-2">
        📚 Ressources Académiques Gratuites
      </h3>
      <p className="text-sm opacity-90">
        Accédez aux cours universitaires par année (Drive)
      </p>

      <div className="mt-4 text-sm font-semibold">
        Gratuit 
      </div>
    </div>
  )}
  {currentCourses.map((course) => {
    const niveauKey = course.niveau?.replace("Niveau:", "").trim();
    const level = levelData[niveauKey] || levelData["Débutant"];
    return (
      <CourseCard
  key={course.id}
  course={course}
  level={level}
  onLike={toggleLike}
  onSave={toggleSave}
  isLiked={!!likedCourses[course.id]}
  isSaved={!!savedCourses[course.id]}
  onRegister={registerCourseNoSubscripption}
  openRatingModal={(profId, onSubmitted) =>
    setProfRatingModal({ isOpen: true, profId, onSubmitted })
  }
/>

    );
  })}
</div>

<UpcomingCourses/>

        {/* Pagination Controls */}
        {courses.length > coursesPerPage && (
          <div className="flex justify-center items-center mt-12 space-x-4">
            <button
              onClick={prevPage}
              disabled={currentPage === 1}
              className={`flex items-center justify-center w-12 h-12 rounded-full transition-all duration-300 ${
                currentPage === 1
                  ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                  : "bg-blue-600 text-white hover:bg-blue-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              }`}
            >
              <FaChevronLeft className="text-lg" />
            </button>

            <div className="flex items-center space-x-2 bg-white px-6 py-3 rounded-full shadow-lg">
              <span className="text-gray-700 font-medium">
                Page <span className="text-blue-600">{currentPage}</span> sur{" "}
                <span className="text-blue-600">{totalPages}</span>
              </span>
              <span className="text-gray-400 mx-2">•</span>
              <span className="text-gray-600">
                {indexOfFirstCourse + 1} -{" "}
                {Math.min(indexOfLastCourse, courses.length)} sur{" "}
                {courses.length} formations
              </span>
            </div>

            <button
              onClick={nextPage}
              disabled={currentPage === totalPages}
              className={`flex items-center justify-center w-12 h-12 rounded-full transition-all duration-300 ${
                currentPage === totalPages
                  ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                  : "bg-blue-600 text-white hover:bg-blue-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              }`}
            >
              <FaChevronRight className="text-lg" />
            </button>
          </div>
        )}
      </div> 
      
      {selectedCourse && !isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <CourseDetailsCard
              course={selectedCourse}
              onClose={() => setSelectedCourse(null)}
              getCoursePrerequisites={getCoursePrerequisites}
              getCourseBenefits={getCourseBenefits}
              getInstructorInfo={getInstructorInfo}
              registerCourse={registerCourse}
              registerCourseNoSubscripption={registerCourseNoSubscripption}
              backToCourses={() => setSelectedCourse(null)}
              closeModal={() => setSelectedCourse(null)}
              style={{
                color: "from-blue-500 to-purple-600",
                bgColor: "bg-blue-50",
                icon: "fas fa-graduation-cap",
              }}
            />
          </div>
        </div>
      )}
      {profRatingModal.isOpen && (
  <RateProfessorModal
    profId={profRatingModal.profId}
    onClose={() => setProfRatingModal({ isOpen: false, profId: null })}
    onSubmitted={profRatingModal.onSubmitted}
  />
)}

    </section>
  );
};

export default AllCoursesPublic;